// client/src/components/marketer/project/modals/AlertModal.js
import React from 'react';
import '../../../../styles/marketer/modals/AlertModal.css';

export default function AlertModal({ open, onClose, message }) {
  if (!open) return null;

  return (
    <div className="alert-modal mbm-overlay">
      <div className="alert-modal__overlay" onClick={onClose}></div>
      <div className="alert-modal__content mbm">
        <div className="alert-modal__message">{message}</div>
        <div className="alert-modal__actions mbm-foot">
          <button
            className="mb-btn mb-btn-primary"
            onClick={onClose}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

